"use client";

import { SchoolData } from "@nimble/candidate-api/types";

import { ActionButtonVariant } from "@/components/shared/buttons/button-variants";
import ExpressInterestButton, {
  ExpressInterestDormantButton,
} from "@/components/shared/buttons/express-interest-button/express-interest-button";
import { publicEnv } from "@/env/public-env";
import { getExpressInterestDormantTooltip } from "@/lib/dormant-season/express-interest-copy";

type ExpressInterestWaitlistContainerProps = {
  schoolId: string;
  schoolData: SchoolData;
  testId?: string;
  variant?: ActionButtonVariant;
  className?: string;
};

export default function ExpressInterestWaitlistContainer({
  schoolId,
  schoolData,
  testId,
  variant = ActionButtonVariant.PrimarySm,
  className,
}: ExpressInterestWaitlistContainerProps) {
  const dormantTooltip = getExpressInterestDormantTooltip(new Date());

  if (dormantTooltip) {
    return (
      <ExpressInterestDormantButton
        tooltipMessage={dormantTooltip}
        variant={variant}
        testId={testId}
        className={className}
      />
    );
  }

  if (publicEnv.NEXT_PUBLIC_ENABLE_EXPRESS_INTEREST) {
    return (
      <ExpressInterestButton
        schoolId={schoolId}
        schoolData={schoolData}
        variant={variant}
        testId={testId}
        className={className}
      />
    );
  }
  return null;
}
